import { render, staticRenderFns } from "./ChangeEvents.vue?vue&type=template&id=ad968d24&"
import script from "./ChangeEvents.vue?vue&type=script&lang=js&"
export * from "./ChangeEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports